import { request } from '../../sharedLegacy/utils'

export const getQueuedVideos = (liveId) => {
  const url = '/api/photo/list'

  return request({
    url,
    method: 'POST',
    data: {
      queued_for_live_id: liveId,
    },
  })
}

export const queueVideo = (videoId, liveId) => {
  const url = '/api/live/queuedvideos/add'

  return request({
    url,
    method: 'POST',
    data: {
      photo_id: videoId,
      live_id: liveId,
    },
  })
}

export const dequeueVideo = (videoId, liveId) => {
  const url = '/api/live/queuedvideos/remove'

  return request({
    url,
    method: 'POST',
    data: {
      photo_id: videoId,
      live_id: liveId,
    },
  })
}
